export enum SphereAdmEnum {
  municipal = 1,
  state = 2
}
